import { useEffect } from 'react';

// ─── Base values ──────────────────────────────────────────────────────────────

const BASE = {
  title: 'Александр — Разработчик Telegram-ботов | @extremum7',
  description:
    'Портфолио разработчика Telegram-ботов с 4-летним опытом. 20+ проектов, 85K+ пользователей. ' +
    'E-commerce, CRM, маркетплейсы, автоматизация. Python, aiogram 3, PostgreSQL. Написать: @extremum7',
  keywords:
    'разработчик telegram ботов, заказать telegram бот, разработка telegram бота python, ' +
    'aiogram разработчик, telegram бот для бизнеса, telegram бот для магазина',
};

// ─── Helpers ──────────────────────────────────────────────────────────────────

/** Set or create a <meta name="..."> tag */
const setMeta = (name, content) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

/** Set or create a <meta property="..."> (Open Graph) tag */
const setOG = (property, content) => {
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

/** Set or create a <link rel="canonical"> */
const setCanonical = (url) => {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', url);
};

/** Inject per-project JSON-LD (SoftwareApplication schema) */
const injectProjectLD = (project) => {
  document.getElementById('__project-ld')?.remove();
  if (!project || project.isProfile) return;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    'name': project.name,
    'description': project.seo_description_ru || project.short_description_ru || '',
    'applicationCategory': 'BusinessApplication',
    'operatingSystem': 'Telegram',
    'inLanguage': 'ru-RU',
    'author': {
      '@type': 'Person',
      '@id': '#developer',
      'name': 'Александр',
    },
    ...(project.link ? { 'url': project.link } : {}),
    ...(project.keywords_ru?.length
      ? { 'keywords': project.keywords_ru.join(', ') }
      : {}),
    'offers': {
      '@type': 'Offer',
      'seller': { '@type': 'Person', 'name': 'Александр', 'url': 'https://t.me/extremum7' },
      'availability': 'https://schema.org/InStock',
    },
  };

  const script = document.createElement('script');
  script.id = '__project-ld';
  script.type = 'application/ld+json';
  script.text = JSON.stringify(schema);
  document.head.appendChild(script);
};

// ─── Hook ─────────────────────────────────────────────────────────────────────

const useSEO = (selectedProject) => {
  useEffect(() => {
    const origin = window.location.origin;

    if (!selectedProject || selectedProject.isProfile) {
      // ── Main / About page
      document.title = BASE.title;
      setMeta('description', BASE.description);
      setMeta('keywords', BASE.keywords);
      setOG('og:title', BASE.title);
      setOG('og:description', BASE.description);
      setOG('og:url', origin + '/');
      setCanonical(origin + '/');
      injectProjectLD(null);
      return;
    }

    // ── Bot project page
    const name = selectedProject.name;
    const title = selectedProject.seo_title_ru
      ? `${selectedProject.seo_title_ru} | @extremum7`
      : `Бот "${name}" — Telegram-бот на заказ | @extremum7`;

    const description =
      selectedProject.seo_description_ru ||
      selectedProject.short_description_ru ||
      BASE.description;

    const keywords = selectedProject.keywords_ru?.length
      ? selectedProject.keywords_ru.join(', ') + ', telegram бот разработка, aiogram'
      : BASE.keywords;

    const url = `${origin}/#${selectedProject.id}`;

    document.title = title;
    setMeta('description', description);
    setMeta('keywords', keywords);
    setOG('og:title', title);
    setOG('og:description', description);
    setOG('og:url', url);
    setCanonical(url);
    injectProjectLD(selectedProject);
  }, [selectedProject]);
};

export default useSEO;
